import type { CheckboxSelectionCallbackParams, ColDef, GridOptions, IRowNode } from 'ag-grid-community';

import { TextButtonCell } from '~/components/common';
import { ManagerNameCellRenderer } from '~/components/vender';

import type { TypeOwnerSupplierManager, TypeOwnerSupplierManagerWithIdAndCode } from '~/types/vender.types';

/**
 * [화주사 정보 관리 > 공급사 관리] 공급사 등록 모달 > '담당자 정보' 테이블
 */
const getVenderSupplierRegisterManagerInfoColumnDefs = ({
  onClickViewDetail,
}: {
  onClickViewDetail: (node: IRowNode<TypeOwnerSupplierManager>) => void;
}) => {
  const gridOptions: GridOptions = {
    defaultColDef: {
      minWidth: 49,
    },
    isRowSelectable: (params: IRowNode<TypeOwnerSupplierManagerWithIdAndCode>) => {
      return params.id !== '0';
    },
    rowClassRules: {
      'ag-row-disabled': (params) => params.node.id === '0',
    },
  };

  const columnDefs: ColDef<TypeOwnerSupplierManager>[] = [
    {
      headerName: '',
      width: 44,
      valueFormatter: () => '',
      headerCheckboxSelection: true,
      checkboxSelection: (params: CheckboxSelectionCallbackParams<TypeOwnerSupplierManager>) => {
        return params.node && params.node.rowIndex !== 0;
      },
      showDisabledCheckboxes: true,
    },
    {
      field: 'ownerSupplierManagerName',
      headerName: '담당자명',
      width: 120,
      cellRenderer: ManagerNameCellRenderer,
    },
    {
      field: 'ownerSupplierManagerPosition',
      headerName: '직위',
      width: 120,
    },
    {
      field: 'ownerSupplierManagerTel',
      headerName: '휴대폰번호',
      width: 140,
    },
    {
      field: 'ownerSupplierManagerEmail',
      headerName: '이메일',
      width: 360,
    },
    {
      headerName: '',
      flex: 1,
      cellRenderer: TextButtonCell,
      cellRendererParams: {
        children: '수정',
        showDashIfNoValue: false,
        onClick: (node: IRowNode<TypeOwnerSupplierManager>) => onClickViewDetail(node),
      },
      cellStyle: { display: 'flex', alignItems: 'center' },
    },
  ];

  return { gridOptions, columnDefs };
};

export default getVenderSupplierRegisterManagerInfoColumnDefs;
